import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_TASK_LINK_DETAILS_QUERY = gql`
  query GetTaskForTaskLink($cloudId: String!) {
    getTask(cloudId: $cloudId) {
      cloudId
      name
      wfDeletedOnUTC
      jobId
    }
  }
` as import('../../__generated__/ts-gql/GetTaskForTaskLink').type;

export type GetTaskForTaskLinkQueryVariables = OperationVariables<
  typeof GET_TASK_LINK_DETAILS_QUERY
>;
export type GetTaskForTaskLinkQueryResult = OperationData<
  typeof GET_TASK_LINK_DETAILS_QUERY
>;

export type TaskLinkDetailsTaskResult = NonNullable<
  ReturnType<typeof processData>
>;

export const useGetTaskLinkDetails = (
  options: QueryHookOptions<
    GetTaskForTaskLinkQueryResult,
    GetTaskForTaskLinkQueryVariables
  >
) => {
  const variables = options.variables as GetTaskForTaskLinkQueryVariables;

  const res = useQuery(GET_TASK_LINK_DETAILS_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });

  return React.useMemo(() => {
    const data = processData(res.data);
    return {
      ...res,
      data,
    };
  }, [res]);
};

export function processData(data: GetTaskForTaskLinkQueryResult | undefined) {
  const task = data?.getTask;
  const result = task && {
    ...task,
    wfDeletedOnUTC: task.wfDeletedOnUTC && new Date(task.wfDeletedOnUTC),
  };
  return result;
}
